import {PipelineElement, piplineConfig} from "../pipeline-builder/PipelineConfig";

export const findElement = (id: string, parent: PipelineElement | null): PipelineElement | null => {
    if (!parent) return null;
    if (parent.id === id) return parent;
    const config = piplineConfig.find(value => value.type === parent.type);
    if (!config || !config.getChildren)
        return null;
    for (const child of config.getChildren(parent)) {
        const found = findElement(id, child);
        if (found) return found;
    }
    return null;
}